import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetMunicipalities_municipalityIdPopulation = z.any()
export type TagsGetMunicipalities_municipalityIdPopulation = z.infer<typeof tagsGetMunicipalities_municipalityIdPopulation>

export const paramsGetMunicipalities_municipalityIdPopulation = z.object({ "municipalityId": z.string() })
export type ParamsGetMunicipalities_municipalityIdPopulation = z.infer<typeof paramsGetMunicipalities_municipalityIdPopulation>

export const responseGetMunicipalities_municipalityIdPopulation = z.object({ "payload": z.number().optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetMunicipalities_municipalityIdPopulation = z.infer<typeof responseGetMunicipalities_municipalityIdPopulation>

interface IGetMunicipalities_municipalityIdPopulation extends BaseMethodType {
  tags: TagsGetMunicipalities_municipalityIdPopulation,
  params: ParamsGetMunicipalities_municipalityIdPopulation,
  response: ResponseGetMunicipalities_municipalityIdPopulation
}
export const URL = '/municipalities/:municipalityId/population'
export const validation = {
  get: {
    tags: tagsGetMunicipalities_municipalityIdPopulation,
    params: paramsGetMunicipalities_municipalityIdPopulation,
    response: responseGetMunicipalities_municipalityIdPopulation
  }
}
export interface Municipalities_municipalityIdPopulation extends BaseRouteType {
  get: IGetMunicipalities_municipalityIdPopulation
}